/** @file initialEditorState: the state every store implementation starts from. */
import type { EditorState } from './editorTypes';

/** Projects screen, unknown session, no puppet (history unknown), rotate tool, local space, pivot, 15 degree snap, profile camera, no overrides. */
export function initialEditorState(url: string): EditorState {
  return {
    route: { screen: 'projects' },
    session: { url, owner: null, status: 'unknown' },
    puppet: { id: null, projectId: null, doc: null, revision: 0, pending: 0, live: 'off', lint: [], lastError: null, history: null },
    selection: { nodes: [], drawable: null, slot: null, keys: [] },
    tool: 'rotate',
    space: 'local',
    pivot: 'pivot',
    snapDeg: 15,
    playhead: { clip: null, frame: 0, playing: false, speed: 1, loop: true },
    camera: { yawDeg: 0, pitchDeg: 30, facingSteps: null, onion: 0, grid: true, joints: false, quads: false },
    preview: { bundle: null, revision: -1, loading: false, error: null },
    poseOverride: null,
    quadOverride: null,
    menu: null,
    toasts: [],
    shell: { menuBar: null, dialog: null, panels: { tree: true, inspector: true, timeline: true }, turntable: false, poseClipboard: null, tiles: [] },
  };
}
